export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'bizVersionNo',
    align: 'left',
    width: 200,
    title: '版本号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizVersionNumber',
    align: 'left',
    width: 140,
    title: '版本序号',
    sortable: true,
    sortType: 'number',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'publishTime',
    align: 'center',
    width: 150,
    title: '发布时间',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'publishDescription',
    align: 'left',
    minWidth: 450,
    title: '发布说明',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizVersionStatusName',
    align: 'center',
    width: 100,
    title: '版本状态',
    slots: { default: 'status' },
  },
  {
    field: 'createTime',
    title: '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
